import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { SelectBox, TimeApiService } from 'cbc-shared-lib';
import { Sgke312aResponseSearchresultHyojiInfo, Sgke312aResponseSearchresultList } from 'sg-api';


@Component({
  selector: 'app-sgke310d-result',
  templateUrl: './sgke310d-result.component.html',
  styleUrl: './sgke310d-result.component.scss'
})
export class Sgke310dResultComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
  /** 検索結果リスト */
  @Input() searchresultList: Array<Sgke312aResponseSearchresultList>;
  /** 検索結果表示情報 */
  @Input() searchresultHyojiInfo: Sgke312aResponseSearchresultHyojiInfo;
  /** 支払期限日より３５日以上経過した判定の基準日 */
  @Input() targetDate = new Date();

  /** クリアボタン押下イベント */
  @Output() onClickApprovalEvent = new EventEmitter();
  /** 登録ボタン押下イベント */
  @Output() onClickRegistEvent = new EventEmitter<Sgke312aResponseSearchresultList[]>();
  /** ダブルクリックEmitter */
  @Output() onDblClickEvent = new EventEmitter();

  /** ソート */
  @ViewChild('sort1', { static: true }) sort!: MatSort;
  /** ページネイター */
  @ViewChild('paginator1', { static: true }) paginator: MatPaginator;

  /** データソース */
  dataSource: MatTableDataSource<Sgke312aResponseSearchresultList>;
  /** 選択した行の情報 */
  selection = new SelectionModel<Sgke312aResponseSearchresultList>(true, []);
  /** 拠点コードリスト */
  kyotenList: SelectBox[] = [];

  /** テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'select',
    'kyoten',
    'claimYmt',
    'payDlineDate',
    'supplystopBreakPlndate',
    'supplystopWorkPlndate',
    'sougouHisougou.aname',
    'parentChild.aname',
    'errorStr',
    'pressManagementdivision.aname',
    'areaTrade.aname',
    'payCtrNo',
    'visitName',
    'nrcptMny',
    'suppntSpno',
    'gastype.aname',
    'supplystopResumeSts.aname',
    'supplystopForceEonflg',
  ];

  /**
   * コンストラクタ
   * @param {ChangeDetectorRef} cd
   * @param {TimeApiService} timeApiService
   * @param {Router} router
   * @memberof Sgke310dResultComponent
   */
  constructor(
    private cd: ChangeDetectorRef,
    public timeApiService: TimeApiService,
    private router: Router,
  ) { }

  /**
   * 初期処理
   * @memberof Sgke310dResultComponent
   */
  ngOnInit(): void {
    // Table表示データ作成
    this.dataSource = new MatTableDataSource<Sgke312aResponseSearchresultList>(this.searchresultList);
    this.setSelector();

    this.dataSource.sortingDataAccessor = (item, property) => {
      return property
        .split('.')
        .reduce((acc, key) => acc?.[key], item);
    };

    this.cd.detectChanges();
  }

  /**
   * 画面描画後初回処理
   * @memberof Sgke310dResultComponent
   */
  ngAfterViewInit() {
    // 表データとソートを連携
    this.dataSource.sort ??= this.sort;
  }

  /**
   * 画面描画後処理
   * @memberof Sgke310dResultComponent
   */
  ngAfterViewChecked() {
    // 表データとページングを連携
    if (this.dataSource) {
      this.dataSource.paginator ??= this.paginator;
    }
  }

  /**
   * 購読解除
   * @memberof Sgke310dResultComponent
   */
  ngOnDestroy() {
  }

  /**
   * 拠点セレクターにリストをセット
   * @memberof Sgke310dResultComponent
   */
  setSelector() {
    // SGKE312Aレスポンス(検索結果表示情報)のコードとコード値をまとめてリスト化
    let retSelectBoxList: SelectBox[] = [];

    this.searchresultHyojiInfo?.baseList?.forEach(data => {
      const select: SelectBox = { value: data.codeValue, viewValue: data.aname };
      retSelectBoxList.push(select);
    })

    this.kyotenList = retSelectBoxList;
  }

  /**
   * チェックボックスが選択されている行のみ拠点選択必須
   * @memberof Sgke310dResultComponent
   */
  registButtonEnableCheck(): boolean {
    // 選択行のすべての拠点コードに有効な値が設定されている場合TRUE、行が選択されていないか行選択時に拠点コードに有効な値が設定されていない場合FALSE
    return this.selection.selected.length > 0 && this.selection.selected.every(row => {
      return row.base.codeValue != '' && row.base.codeValue != undefined;
    });
  }

  /**
   * 全選択チェック
   * @readonly
   * @memberof Sgke310dResultComponent
   */
  get isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;

    return numSelected === numRows;
  }

  /**
   * 全選択
   * @memberof Sgke310dResultComponent
   */
  onClickAllCheck(): void {
    this.dataSource.data.forEach(row => {
      this.selection.select(row);
    });
  }

  /**
   * 全選択解除
   * @memberof Sgke310dResultComponent
   */
  onClickAllClear(): void {
    this.selection.clear();
  }

  /**
   * 支払期限日より３５日以上経過した行を黄色背景にする
   * @param {Sgke312aResponseSearchresultList} row
   * @return {*}
   * @memberof Sgke310dResultComponent
   */
  getBackgroudColor(row: Sgke312aResponseSearchresultList) {
    if(row.payDlineDate){
      // 支払期限日
      let limit = new Date(this.timeApiService.convertStringToDate(row.payDlineDate));
      // 支払期限日より３５日後
      limit.setDate(this.timeApiService.convertStringToDate(row.payDlineDate).getDate() + 35);
      // 対象日がlimit以上の場合は、背景黄色
      return limit <= this.targetDate ? 'yellow' : 'none';
    }
    return 'none';
  }

  /**
   * SGKA004D：請求ポータル画面に遷移
   * @param {*} row
   * @memberof Sgke310dResultComponent
   */
  onDblClickRow(row:Sgke312aResponseSearchresultList) {
    this.onDblClickEvent.emit(row);
  }

  /**
   * 登録ボタン押下
   * @memberof Sgke310dResultComponent
   */
  onClickRegist() {
    this.onClickRegistEvent.emit(this.selection.selected);
  }
}
